import BaseHttpClient from '../../base'
import { apis, getApiUrl } from '../api-config'

/**
 * Student auth
 */
class AuthStudentAPI extends BaseHttpClient {}

export default new AuthStudentAPI('v1/students', 'Student', getApiUrl(apis.AuthAPI))
